export default __webpack_public_path__ + "static/media/Notification-dot.356b177c.svg";